import HttpFactory from '@/mixins/http.factory';

export default {
	name:'forgotpassword',
	mixins:[HttpFactory],
	data () {
    return {
      email:''
    }
},

	methods:{
		async recoverPassword(){
			const _self=this;
			let data={
				email:this.email
			};
			_self.fn().clearMessage();
			try{
				let response =await _self.post('auth/forgotPassword',data);
				if(response && response.data && response.data.Success){
					_self.userMsg.type='info';
					_self.userMsg.list=[response.data.Response.Message];	
				}else{
					_self.userMsg.list=['An error occurred!! Please try again later'];
				}
			}catch(ex){
				_self.commonErrorMsgDisp(ex);
			}finally{
				_self.userMsg.show=true;
				_self.fn().showLoader(false);
			}
		}
	}
}

